module.exports = __webpack_public_path__ + "img/promotion1_roll3.41d0be29.jpg";